module.exports = __webpack_public_path__ + "static/media/certik-logo-w.d7783703.png";